import { forwardRef } from 'react';

const WhiteCard = forwardRef(function WhiteCard(
    { children, verticalMargin = 'my-6', bg = 'bg-grayBgNormal', shadow = 'shadow-md', className, ...props },
    ref
) {
    return (
        <div {...props} ref={ref} className={`${bg} ${shadow}  ${verticalMargin}  rounded-md ${className} `}>
            {children}
        </div>
    );
});

export default WhiteCard;
